import { render, staticRenderFns } from "./ImmutablePhrasesTable.vue?vue&type=template&id=be9c6352"
import script from "./ImmutablePhrasesTable.vue?vue&type=script&lang=js"
export * from "./ImmutablePhrasesTable.vue?vue&type=script&lang=js"
import style0 from "./ImmutablePhrasesTable.vue?vue&type=style&index=0&id=be9c6352&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports